<template>
	<div>
		<div class="row">
			<div class="col-12">
				<div class="page-title-box d-flex align-items-center justify-content-between">
					<h4 class="mb-0">Главная</h4>
					<div class="page-title-right">
						<ol class="breadcrumb m-0">
							<li class="breadcrumb-item active">Главная</li>
						</ol>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-lg-12">
				<div class="card">
					<div class="card-body">
						<h4 class="card-title mb-4">Latest Transaction</h4>
						<div class="table-responsive">
							<table class="table table-centered table-nowrap mb-0">
								<thead class="table-light">
									<tr>
										<th style="width: 20px;">
											<div class="form-check font-size-16">
												<input type="checkbox" class="form-check-input" id="customCheck1" />
												<label class="form-check-label" for="customCheck1">&nbsp;</label>
											</div>
										</th>
										<th>Order ID</th>
										<th>Billing Name</th>
										<th>Date</th>
										<th>Total</th>
										<th>Payment Status</th>
										<th>Payment Method</th>
										<th>View Details</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>
											<div class="form-check font-size-16">
												<input type="checkbox" class="form-check-input" id="customCheck2" />
												<label class="form-check-label" for="customCheck2">&nbsp;</label>
											</div>
										</td>
										<td><a href="javascript: void(0);" class="text-body fw-bold">#MB2540</a> </td>
										<td>Neal Matthews</td>
										<td>
											07 Oct, 2019
										</td>
										<td>
											$400
										</td>
										<td>
											<span class="badge rounded-pill bg-soft-success font-size-12">Paid</span>
										</td>
										<td>
											<i class="fab fa-cc-mastercard me-1"></i> Mastercard
										</td>
										<td>
											<button type="button" class="btn btn-primary btn-sm btn-rounded waves-effect waves-light">
												View Details
											</button>
										</td>
									</tr>
									<tr>
										<td>
											<div class="form-check font-size-16">
												<input type="checkbox" class="form-check-input" id="customCheck3" />
												<label class="form-check-label" for="customCheck3">&nbsp;</label>
											</div>
										</td>
										<td><a href="javascript: void(0);" class="text-body fw-bold">#MB2541</a> </td>
										<td>Jamal Burnett</td>
										<td>
											07 Oct, 2019
										</td>
										<td>
											$380
										</td>
										<td>
											<span class="badge rounded-pill bg-soft-danger font-size-12">Chargeback</span>
										</td>
										<td>
											<i class="fab fa-cc-visa me-1"></i> Visa
										</td>
										<td>
											<button type="button" class="btn btn-primary btn-sm btn-rounded waves-effect waves-light">
												View Details
											</button>
										</td>
									</tr>
									<tr>
										<td>
											<div class="form-check font-size-16">
												<input type="checkbox" class="form-check-input" id="customCheck4" />
												<label class="form-check-label" for="customCheck4">&nbsp;</label>
											</div>
										</td>
										<td><a href="javascript: void(0);" class="text-body fw-bold">#MB2542</a> </td>
										<td>Juan Mitchell</td>
										<td>
											06 Oct, 2019
										</td>
										<td>
											$384
										</td>
										<td>
											<span class="badge rounded-pill bg-soft-success font-size-12">Paid</span>
										</td>
										<td>
											<i class="fab fa-cc-paypal me-1"></i> Paypal
										</td>
										<td>
											<button type="button" class="btn btn-primary btn-sm btn-rounded waves-effect waves-light">
												View Details
											</button>
										</td>
									</tr>
									<tr>
										<td>
											<div class="form-check font-size-16">
												<input type="checkbox" class="form-check-input" id="customCheck5" />
												<label class="form-check-label" for="customCheck5">&nbsp;</label>
											</div>
										</td>
										<td><a href="javascript: void(0);" class="text-body fw-bold">#MB2543</a> </td>
										<td>Barry Dick</td>
										<td>
											05 Oct, 2019
										</td>
										<td>
											$412
										</td>
										<td>
											<span class="badge rounded-pill bg-soft-success font-size-12">Paid</span>
										</td>
										<td>
											<i class="fab fa-cc-mastercard me-1"></i> Mastercard
										</td>
										<td>
											<button type="button" class="btn btn-primary btn-sm btn-rounded waves-effect waves-light">
												View Details
											</button>
										</td>
									</tr>
									<tr>
										<td>
											<div class="form-check font-size-16">
												<input type="checkbox" class="form-check-input" id="customCheck6" />
												<label class="form-check-label" for="customCheck6">&nbsp;</label>
											</div>
										</td>
										<td><a href="javascript: void(0);" class="text-body fw-bold">#MB2544</a> </td>
										<td>Ronald Taylor</td>
										<td>
											04 Oct, 2019
										</td>
										<td>
											$404
										</td>
										<td>
											<span class="badge rounded-pill bg-soft-warning font-size-12">Refund</span>
										</td>
										<td>
											<i class="fab fa-cc-visa me-1"></i> Visa
										</td>
										<td>
											<button type="button" class="btn btn-primary btn-sm btn-rounded waves-effect waves-light">
												View Details
											</button>
										</td>
									</tr>
									<tr>
										<td>
											<div class="form-check font-size-16">
												<input type="checkbox" class="form-check-input" id="customCheck7" />
												<label class="form-check-label" for="customCheck7">&nbsp;</label>
											</div>
										</td>
										<td><a href="javascript: void(0);" class="text-body fw-bold">#MB2545</a> </td>
										<td>Jacob Hunter</td>
										<td>
											04 Oct, 2019
										</td>
										<td>
											$392
										</td>
										<td>
											<span class="badge rounded-pill bg-soft-success font-size-12">Paid</span>
										</td>
										<td>
											<i class="fab fa-cc-paypal me-1"></i> Paypal
										</td>
										<td>
											<button type="button" class="btn btn-primary btn-sm btn-rounded waves-effect waves-light">
												View Details
											</button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="css" scoped>

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

export default {
	name: 'Main',
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Главная | Krasp'});
	},
	data: () => ({
		
	}),
	methods: {
		
	},
	beforeMount(){
		window.scrollTo(0, 0);
	},
	beforeRouteUpdate(to, from, next){
		next();
		window.scrollTo(0, 0);
	},
	computed: {},
	components: {
		//Navbar,
	},
};
</script>